module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/02-6cf7fc06e6e8c5bb210a7a2a8abe7c31.jpg";